import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { sociosData } from '../data/sociosData';

export default function Socios() {
  const { language } = useLanguage();
  const t = {
    es: { title: "Confían en Nosotros" },
    en: { title: "They Trust Us" }
  };

  return (
    <div className="bg-background text-on-surface font-body border-y border-border">
      <section className="pt-10 pb-16 px-8 max-w-[1400px] mx-auto text-center">

        {/* Label Section - Centered on Top */}
        <div className="anim-fade-up anim-delay-5 mb-16">
          <p className="text-primary font-headline text-3xl md:text-4xl font-extrabold tracking-tight">{t[language].title}</p>
          <div className="w-16 h-1 bg-secondary mx-auto mt-6"></div>
        </div>

        {/* Logo Grid - Horizontal Row(s) */}
        <div className="anim-fade-up anim-delay-6 flex flex-wrap justify-center items-center gap-x-12 gap-y-12 md:gap-x-20 md:gap-y-16 opacity-40 grayscale">
          {sociosData.map((logo, index) => (
            <div
              key={index}
              className="flex items-center justify-center transition-all duration-500 hover:scale-110 cursor-default"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-10 md:h-12 lg:h-14 w-auto object-contain filter drop-shadow-sm"
              />
            </div>
          ))}
        </div>

      </section>
    </div>
  );
}
// Clean and decoupled version of the partners gallery.